import {
  enUS as enLocale,
  es as esLocale,
  fr as frLocale,
} from "date-fns/locale";
import { Locale } from "date-fns";

/**
 * Object that maps available locale names to date-fns locales objects. Used for @mui date pickers
 * and for date formatting with locales. This should be kept updated with all languages used in the
 * application.
 */
export const dateLocaleMap: Record<string, Locale> = {
  en: enLocale,
  es: esLocale,
  fr: frLocale,
};
